import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {NumberInput} from "./inputs";
import * as Yup from "yup";
import {useSelector} from "react-redux";


const schema = Yup.object({
  firstname: Yup.string().max(255).required(),
  lastname: Yup.string().max(255).required(),
  email: Yup.string().email().max(255).required(),
  phone: Yup.string().max(255).required(),
  postcode: Yup.string().max(255),
  city: Yup.string().max(255),
  address: Yup.string().max(255),
  message: Yup.string().max(1000),
})


export default function CustomerDetailsForm(props) {
  const store = useSelector(({main}) => ({
    customerDetails: main.customerDetails,
  }))
  const formMethods = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      ...schema.getDefault(),
      ...store.customerDetails,
    },
  })

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(props.onSubmit)}>
        <div className="mb-4">
          <div className="row">
            <div className="col-sm-6">
              <NumberInput name="firstname" label="Imię"/>
            </div>
            <div className="col-sm-6">
              <NumberInput name="lastname" label="Nazwisko"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <NumberInput name="postcode" label="Kod pocztowy"/>
            </div>
            <div className="col-sm-8">
              <NumberInput name="city" label="Miasto"/>
            </div>
          </div>
          <NumberInput name="address" label="Adres"/>
          <NumberInput name="phone" label="Telefon kontaktowy"/>
          <NumberInput name="email" label="Adres email"/>
        </div>

        <button className="btn btn-primary w-100">Dalej</button>
      </form>
    </FormProvider>
  )
}